import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/LoginView.vue')
  },
  {
    path: '/product/:cats',
    name: 'product',
    component: ()=>import('@/views/ProductView.vue')
  },
  {
    path: '/details/:id',
    name: 'details',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DetailsView.vue')
  },
  {
    path: '/order/details/:order_sn',
    name: 'order_details',
    component: () => import(/* webpackChunkName: "about" */ '@/views/OrderDetailsView.vue')
  },
  {
    path: '/order/list',
    name: 'order_list',
    component: () => import(/* webpackChunkName: "about" */ '@/views/OrderListView.vue')
  },
  {
    path: '/into',
    name: 'into',
    component: () => import(/* webpackChunkName: "about" */ '@/views/IntoView.vue')
  },
  {
    path: '/china_airport',
    name: 'china_airport_recharge',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ChinaView.vue')
  },
  {
    path: '/third_page/:code',
    name: 'third_page',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ThirdPage.vue')
  },
  {
    path: '/movie',
    name: 'movie',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Movie.vue')
  },
  {
    path: "/not/fount",
    name: "404",
    component: ()=>import('@/views/404.vue')
  },
  {
    path: '/hainan_airport',
    name: 'hainan_airport_recharge',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HainanView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to,from,next)=>{
  document.title = to.meta.title ? to.meta.title : '航空积分权益兑换平台';
  const ro = routes.map(i=>i.name)
  if(!ro.some(t=>to.name === t)){
    next({name:'404',query: {path:to.fullPath}})
    return;
  }
  next()
})

export default router
